import type { LevelView } from "@nabla/api";
import { stockRuleCopy as t } from "./copy.ts";

export const sections = {
  product: (view: LevelView) => {
    const section = view.modules?.["stock-rule"];
    return section?.low ? { text: t.noLimite(section.floor), warn: true } : undefined;
  },
};
